import React, { useContext, useRef, useState } from 'react';
import * as S from './PromptTimeSelectBox.style';
import Image from '../../../../components/image/Image';
import useClickOutside from '../../../../hooks/useClickOutside';
import { RootStoreContext } from '../../../../App';

import useAttendanceMutation from '../../../../hooks/queries/useAttendanceMutation';

const hourList = Array.from({ length: 24 }, (_, index) =>
	index.toString().padStart(2, '0'),
);
const minuteList = Array.from({ length: 60 }, (_, index) =>
	index.toString().padStart(2, '0'),
);

const PromptTimeSelectBox = ({ click, onClick, user, date, time, type }) => {
	const { authStore } = useContext(RootStoreContext);
	const [hour, setHour] = useState(time?.[0].toString().padStart(2, '0'));
	const [minute, setMinute] = useState(time?.[1].toString().padStart(2, '0'));

	const attendanceMutation = useAttendanceMutation();
	const isLoading = attendanceMutation.isLoading;

	const selectChange = (isNow) => {
		let updateHour = parseInt(hour);
		let updateMinutes = parseInt(minute);
		if (isNow) {
			const currentTime = new Date();
			updateHour = currentTime.getHours();
			updateMinutes = currentTime.getMinutes();
		}

		const updateTime = `${date.getFormatDate(
			'yyyy,MM,dd',
		)},${updateHour},${updateMinutes},0`;

		const updateData = {
			id: user?.attendanceId || 0,
			state: user.state,
			startTime:
				type === 'start'
					? updateTime
					: `${date.getFormatDate('yyyy,MM,dd')},${user.startTime[0]},${
							user.startTime[1]
					  },0`,
			endTime:
				type === 'end'
					? updateTime
					: `${date.getFormatDate('yyyy,MM,dd')},${user.endTime[0]},${
							user.endTime[1]
					  },0`,
			faceId: user.id,
			collectionId: authStore.auth.collectionId,
		};
		attendanceMutation.mutate(updateData);
		onClick();
	};

	return (
		<S.Container isLoading={isLoading}>
			<button onClick={onClick} disabled={isLoading}>
				{isLoading ? (
					<S.LoadingSpinner />
				) : click ? (
					`${hour}:${minute}`
				) : (
					`${time?.[0].toString().padStart(2, '0')}:${time?.[1]
						.toString()
						.padStart(2, '0')}`
				)}
				{/* <Image srcArray={S.arrow_right_list} /> */}
			</button>
			{!isLoading && (
				<S.OptionsWrap click={click}>
					<div className='times'>
						<div className='time'>
							{hourList.map((h, index) => {
								return (
									<li
										key={`hour_${h}`}
										className={h === hour ? 'click' : undefined}
										onClick={() => setHour(hourList[index])}>
										{h}
									</li>
								);
							})}
						</div>
						<div className='time'>
							{minuteList.map((m, index) => {
								return (
									<li
										key={`minute_${m}`}
										className={m === minute ? 'click' : undefined}
										onClick={() => setMinute(minuteList[index])}>
										{m}
									</li>
								);
							})}
						</div>
					</div>
					<div className='buttons'>
						<button onClick={() => selectChange(true)}>NOW</button>
						<button onClick={() => selectChange(false)}>OK</button>
					</div>
				</S.OptionsWrap>
			)}
		</S.Container>
	);
};

export default PromptTimeSelectBox;
